module.exports = __webpack_public_path__ + "static/media/zakaria.3350cbbd.png";